export default __webpack_public_path__ + "static/media/icon_error.888eb9d3.svg";